/**
 * app.js
 */
import process from 'process/browser';
import { Buffer } from 'buffer';
window.process = process;
window.Buffer = Buffer;

// Needed for redux-saga es6 generator support
import '@babel/polyfill';

// Import all the third party stuff
import { ConnectedRouter } from 'connected-react-router';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import 'sanitize.css/sanitize.css';
import history from 'utils/history';

import { CssBaseline } from '@material-ui/core';

// Import root app
import App from 'containers/App';
import ErrorBoundary from 'components/ErrorBoundary';

// Import Language Provider
import LanguageProvider from 'containers/LanguageProvider';

// Load the favicon and the .htaccess file
/* eslint-disable import/no-unresolved, import/extensions */
import '!file-loader?name=[name].[ext]!./images/favicon.ico';
import 'file-loader?name=.htaccess!./.htaccess';
/* eslint-enable import/no-unresolved, import/extensions */

import configureStore from './configureStore';

import { ThemeProvider } from '@material-ui/core/styles';
import theme from './themes/default.js';
// Import i18n messages
import { translationMessages } from './i18n';

// Create redux store with history
const initialState = {};
const store = configureStore(initialState, history);
const MOUNT_NODE = document.getElementById('app');

const render = messages => {
  ReactDOM.render(
    <Provider store={store}>
      <LanguageProvider messages={messages}>
        <ConnectedRouter history={history}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            {/* Inside the theme so the fallback screen can style itself. */}
            <ErrorBoundary>
              <App />
            </ErrorBoundary>
          </ThemeProvider>
        </ConnectedRouter>
      </LanguageProvider>
    </Provider>,
    MOUNT_NODE
  );
};

// if (process.env.NODE_ENV === 'production') {
//   Sentry.init({
//     dsn: 'https://b564861d07634a0a9866933bf384848f@o1309758.ingest.sentry.io/6558208',
//     integrations: [new BrowserTracing()],
//     tracesSampleRate: 1.0
//   });
// }

if (module.hot) {
  // Hot reloadable React components and translation json files
  // modules.hot.accept does not accept dynamic dependencies,
  // have to be constants at compile-time
  module.hot.accept(['./i18n', 'containers/App'], () => {
    ReactDOM.unmountComponentAtNode(MOUNT_NODE);
    render(translationMessages);
  });
}

// Chunked polyfill for browsers without Intl support
if (!window.Intl) {
  new Promise(resolve => {
    resolve(import('intl'));
  })
    .then(() => Promise.all([import('intl/locale-data/jsonp/en.js')]))
    .then(() => render(translationMessages))
    .catch(err => {
      throw err;
    });
} else {
  render(translationMessages);
}

// Install ServiceWorker and AppCache in the end since
// it's not most important operation and if main code fails,
// we do not want it installed
if (process.env.NODE_ENV === 'production') {
  require('offline-plugin/runtime'); // eslint-disable-line global-require
}

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/firebase-messaging-sw.js').catch(error => {
    console.error('Error during service worker registration:', error);
  });
}
